import { useParams } from 'react-router-dom';

export const useEventFormParams = () => {
  const { eventId: rawEventId, stepId: rawStepId, formId: rawFormId } = useParams();
  const eventId = Number(rawEventId);
  const stepId = Number(rawStepId);
  const formId = Number(rawFormId);

  return { eventId, stepId, formId };
};
